/* ═══════════════════════════════════════════
   BRAD JACOBS MD — Scroll Reveal & Interactions
   ═══════════════════════════════════════════
   This handles:
   - Scroll-triggered fade-in animations (.bj-reveal)
   - Re-initializes when sections are added/edited in
     the Shopify theme editor (the critical fix)
   - Fallback: if anything fails, content is still visible
═══════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ────────────────────────────────────────────
  // 1. SCROLL REVEAL
  // ────────────────────────────────────────────
  function initBjReveal(root) {
    root = root || document;
    var elements = root.querySelectorAll('.bj-reveal:not(.bj-observed)');
    if (!elements.length) return;

    // Browser doesn't support IntersectionObserver — just show everything
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(elements, function(el) {
        el.classList.add('visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });

    Array.prototype.forEach.call(elements, function(el) {
      el.classList.add('bj-observed');
      observer.observe(el);
    });
  }

  // ────────────────────────────────────────────
  // 2. PILLAR ACCORDION (Approach page)
  // ────────────────────────────────────────────
  function initBjPillars(root) {
    root = root || document;
    var pillars = root.querySelectorAll('.bj-pillar:not(.bj-pillar-init)');
    if (!pillars.length) return;

    Array.prototype.forEach.call(pillars, function(pillar) {
      pillar.classList.add('bj-pillar-init');
      var header = pillar.querySelector('.bj-pillar-hd');
      if (!header) return;

      header.addEventListener('click', function() {
        var isOpen = pillar.classList.contains('open');
        // Close all pillars in this group
        var siblings = pillar.parentElement.querySelectorAll('.bj-pillar');
        Array.prototype.forEach.call(siblings, function(s) {
          s.classList.remove('open');
        });
        if (!isOpen) pillar.classList.add('open');
      });
    });
  }

  // ────────────────────────────────────────────
  // 3. CAROUSEL (M3 Get Started page)
  // ────────────────────────────────────────────
  function initBjCarousel(root) {
    root = root || document;
    var carousels = root.querySelectorAll('.bj-carousel-wrap:not(.bj-carousel-init)');
    if (!carousels.length) return;

    Array.prototype.forEach.call(carousels, function(wrap) {
      wrap.classList.add('bj-carousel-init');
      var track = wrap.querySelector('.bj-carousel-track');
      var cards = wrap.querySelectorAll('.bj-carousel-card');
      var prevBtn = wrap.querySelector('.bj-arrow-prev');
      var nextBtn = wrap.querySelector('.bj-arrow-next');
      if (!track || !cards.length) return;

      var current = 0;
      var total = cards.length;

      function update() {
        var w = cards[0].offsetWidth + 28; // card width + gap
        track.style.transform = 'translateX(-' + (current * w) + 'px)';
        Array.prototype.forEach.call(cards, function(c, i) {
          c.classList.toggle('dim', i !== current);
        });
        if (prevBtn) prevBtn.classList.toggle('off', current === 0);
        if (nextBtn) nextBtn.classList.toggle('off', current === total - 1);
      }

      function move(dir) {
        var next = current + dir;
        if (next < 0 || next >= total) return;
        current = next;
        update();
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { move(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { move(1); });

      // Touch swipe support
      var startX = 0;
      track.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function(e) {
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 50) move(diff < 0 ? 1 : -1);
      }, { passive: true });

      update();
      window.addEventListener('resize', update);
    });
  }

  // ────────────────────────────────────────────
  // INITIALIZE EVERYTHING
  // ────────────────────────────────────────────
  function initAll(root) {
    initBjReveal(root);
    initBjPillars(root);
    initBjCarousel(root);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }

  // Run again on full page load (catches anything async)
  window.addEventListener('load', function() { initAll(); });

  // ── CRITICAL: Re-init when Shopify reloads sections in the theme editor ──
  // Without this, scroll animations break every time you edit a section
  document.addEventListener('shopify:section:load', function(e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:reorder', function(e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:select', function(e) {
    initAll(e.target);
  });

})();
